var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookMessenger1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 2.66663C8.99967 2.66663 3.33301 8.06663 3.33301 14.6666C3.33301 18.1333 4.86634 21.2 7.33301 23.4V29.3333L12.533 26.2C13.5997 26.4666 14.7997 26.6666 15.9997 26.6666C22.9997 26.6666 28.6663 21.2666 28.6663 14.6666C28.6663 8.06663 22.9997 2.66663 15.9997 2.66663Z",
    fill: "#448AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.6667L14.6667 11.3334L18 14.6667L24 11.3334L17.3333 18.6667L14 15.3334L8 18.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMessenger1);
export default __webpack_public_path__ + "static/media/facebook-messenger 1.dfd35762e2a6fc3896d2b83ffd34a6f5.svg";
export { ForwardRef as ReactComponent };